import dayjs, { Dayjs } from 'dayjs';
import {
  IMappedScheduleDateData,
  mappedGroupSchedule,
  mappedTeacherSchedule,
} from 'entities/types';
import { formatTimeRange } from 'shared/lib';
import { getParity, WeekParity } from 'shared/lib';

import 'dayjs/locale/ru';

dayjs.locale('ru');

export const mapScheduleDateData = (
  startDate: Dayjs,
  endDate: Dayjs,
  data: mappedGroupSchedule | mappedTeacherSchedule,
): IMappedScheduleDateData[] => {
  const dateDataArray: IMappedScheduleDateData[] = [];
  const daysQuantity = endDate.diff(startDate, 'day');
  if (data.length === daysQuantity) {
    for (let i = 0; i < daysQuantity; i++) {
      if (data[i].length) {
        const dayScheduleArray = data[i];
        const date = dayjs(dayScheduleArray[0].date.toDate());
        const now = dayjs(new Date());
        const parity = getParity(dayScheduleArray[0].date.toDate());

        const dateData: IMappedScheduleDateData = {
          date: date.locale('ru').format('D MMMM, dd'),
          isPrimary: date.isSame(now, 'day'),
          key: date.locale('ru').format('DD.MM.YYYY'),
          lessonQuantity: dayScheduleArray.length,
          timeInterval: `${dayScheduleArray[0].disciplTime} — ${formatTimeRange(dayScheduleArray[dayScheduleArray.length - 1].disciplTime)}`,
          weekParity:
            parity === WeekParity.Even ? 'четная неделя' : 'нечетная неделя',
          dateDayjs: date,
        };
        dateDataArray.push(dateData);
      } else {
        const date = startDate.add(i, 'day');
        const now = dayjs(new Date());
        const parity = getParity(date.toDate());
        const dateData: IMappedScheduleDateData = {
          date: date.locale('ru').format('D MMMM, dd'),
          isPrimary: date.isSame(now, 'day'),
          key: date.locale('ru').format('DD.MM.YYYY'),
          lessonQuantity: 0,
          timeInterval: '',
          weekParity:
            parity === WeekParity.Even ? 'четная неделя' : 'нечетная неделя',
          dateDayjs: date,
        };
        dateDataArray.push(dateData);
      }
    }
  }

  return dateDataArray;
};
